export default "__VITE_ASSET__qTWQzBv___"